module.exports = __webpack_public_path__ + "static/media/icon-infocircle.cf211a82.svg";